import styled, { css } from 'styled-components';
import { Typography } from 'antd';

export const StyledTypo = styled(Typography.Link)`
    && {
        ${({ theme }) => css`
            color: ${theme.colors.accentColor};
        `}
    }
`;
